import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./Reducer";
import numberSlice from "./Number";
export default configureStore({
    reducer: {
        user: userSlice,
        num: numberSlice
    }
});